//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faTasks,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { RolInterface } from "../../../../interfaces/RolInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";

//estilos
const classes = require("./RolesTable.module.css").default;

type Rol = {
  id: number;
  nombre: string;
  descripcion: string;
};

const RolesTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [roles, setRoles] = useState<RolInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los prueba traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setRoles(variable.data);
  }, []);

  //Función que llama todos los prueba paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/rol",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  const columns = useMemo<ColumnDef<Rol>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Descripcion",
        accessorFn: (row) => row.descripcion,
        id: "descripcion",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar rol"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(`/main/catalogos/roles/edit/${info.row.original.id}`)
              }
              disabled={!authContext.tokenCan("Rol:update")}
            >
              <FontAwesomeIcon icon={faPen as IconProp} />
            </Button>
            <Button
              title="Asignar permisos"
              style={{ backgroundColor: "#21618C", borderColor: "white" }}
              onClick={() =>
                navigate(
                  `/main/catalogos/roles/asignar/${info.row.original.id}`
                )
              }
              disabled={!authContext.tokenCan("Rol:assign")}
            >
              <FontAwesomeIcon icon={faTasks as IconProp} />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!roles) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de roles</h2>
      {/** Botón para agregar usuario */}
      {authContext.tokenCan("Rol:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva función"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/roles/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus as IconProp} /> Nuevo rol
          </Button>
        </div>
      )}
      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: roles,
          columns,
        }}
      />
    </Container>
  );
};

export default RolesTable;
